
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-generals-23j-2023/resultats",
      function () {
        return require("private-next-pages/3catinfo/eleccions-generals-23j-2023/resultats/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-generals-23j-2023/resultats"])
      });
    }
  